export default "__VITE_ASSET__CospV9fy__"